var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiCheckbox from '@material-ui/core/Checkbox';
/**
 * Kareo wrapped component of the Material-UI Checkbox. The prop API has been limited to props defined in CheckboxProps.
 *
 * Checkboxes allow the user to check (i.e select) multiple options from a set.
 * Use checkboxes when there is a list of options and the user may select any number of choices, including none at all.
 * Each check is independent of any other checkbox in the list; checking one box does not uncheck the others.
 *
 * Material-UI Checkbox: [Docs](https://v4.mui.com/components/checkboxes/), [API](https://v4.mui.com/api/checkbox/)
 *
 * @storybook: [Checkbox](http://design.kareoprod.ent/design-system/?path=/story/components-inputs-checkbox--checkbox-storybook)
 */
var Checkbox = React.forwardRef(function (props, ref) {
    return (React.createElement(MuiCheckbox, __assign({}, props, { ref: ref, color: "primary", disableFocusRipple: true, disableRipple: true })));
});
Checkbox.defaultProps = {};
Checkbox.displayName = 'KareoCheckbox';
export default Checkbox;
